module.exports = __webpack_public_path__ + "img/mahimahi.78c512d9.png";